import React from 'react';
import { Typography } from '../Typography';
import AppButton from 'src/components/base/Button/Button';
import { useDispatch } from 'react-redux';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useTranslation } from 'react-i18next';

interface MatchScoreInvitationModalProps {
  handleYesClick: () => void;
}

const MatchScoreInvitationModal: React.FC<MatchScoreInvitationModalProps> = ({
  handleYesClick,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('matchScoreConfirmationModal');

  return (
    <>
      <div className="match-score-modal ms-5 me-5">
        <div className="mt-4 text-1">
          <Typography variant="size-20">
            {t('matchScoreInvitationModal.title.startText')}{' '}
            <span className="font-weight-bold">
              {t('matchScoreInvitationModal.title.boldText')}
            </span>
            &nbsp; {t('matchScoreInvitationModal.title.endText')}
          </Typography>
        </div>
        <div className="mt-5 text-2">
          <Typography variant="size-20">
            {t('matchScoreInvitationModal.disclaimerQuestion')}
          </Typography>
        </div>
        <div className="mt-5 mb-4 d-flex justify-content-center button-container">
          <AppButton
            label={t('matchScoreInvitationModal.buttonLabels.yes')}
            onClick={handleYesClick}
          />
          <AppButton
            onClick={() => dispatch(clearModalContent())}
            className="ms-5 bg-white"
            variant="light"
            label={t('matchScoreInvitationModal.buttonLabels.no')}
          />
        </div>
      </div>
    </>
  );
};

export default MatchScoreInvitationModal;
